import ArrowUpDownIcon from '@src/components/icons/ArrowUpDown'

interface IToggleExchangeTokensProps {
    onToggleExchangeTokens: () => void
}

export function ToggleExchangeTokens({ onToggleExchangeTokens }: IToggleExchangeTokensProps) {
    return (
        <div className='relative'>
            <div className='absolute left-1/2 -translate-x-1/2 -translate-y-1/2 items-center justify-center'>
                <div
                    className='swap-exchange-toggle flex h-[46px] w-[46px] cursor-pointer items-center justify-center rounded-[8px] border-[5px] border-[#111112] bg-[#161719] text-white'
                    onClick={onToggleExchangeTokens}
                >
                    <ArrowUpDownIcon className='ml-[3px] mt-[2px] hover:opacity-80' />
                </div>
            </div>
        </div>
    )
}
